import React from "react";

import ButtonDeprecated from "core/gd-components/buttons/gd-button/gd-button";

export default function ModalAddUserSubmit(props) {

    if (['task','chat','common','company-admin'].includes(props.mode) && !props.multiselect) return false;

    const type = props.canSubmit ? 'primary' : 'normal';

    return (
        <div className="modal-submit">
            <ButtonDeprecated type={type} label="Submit" onClick={props.onClickSubmit} />
        </div>
    )
}